import * as React from 'react';
import MyAppBar from './MyAppBar';
import Sidebar from './Sidebar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';

const drawerWidth = 240;

export default function NoSidebarLayout(props) {
  const { window, children } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <MyAppBar />

      <Box component='main' sx={{ flexGrow: 1, p: 3, backgroundColor: '#EEEEEE' }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}
